export default __webpack_public_path__ + "static/media/doctor.d25496ba.png";